export default __webpack_public_path__ + "static/media/discord.f87c4d75.png";